<template>

  <div>

    <div class="col-lg-12" style="margin-top: 16px;">
      <div class="alert alert-info" role="alert">
        Wybierz ilość minut, godzin lub dni wstecz, aby wyznaczyć moment od którego mają być podsumowywane statystyki przesyłania plików.
        <strong>Ustawienie wszystkich wartości na 0 spowoduje pobranie danych od początku.</strong>
      </div>
    </div>

    <div class="row" style="margin-top: 16px;">
      <div class="col-lg-4">
        <div class="form-group
        ">
          <label for="daysBackwards">Dni wstecz</label>
          <input type="number" class="form-control" id="daysBackwards" v-model="timeBackwardsRequest.daysBackwards">
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group
        ">
          <label for="hoursBackwards">Godziny wstecz</label>
          <input type="number" class="form-control" id="hoursBackwards" v-model="timeBackwardsRequest.hoursBackwards">
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group
        ">
          <label for="minutesBackwards">Minuty wstecz</label>
          <input type="number" class="form-control" id="minutesBackwards" v-model="timeBackwardsRequest.minutesBackwards">
        </div>
      </div>




    </div>

      <div class="row" style="margin-top: 16px;">
        <div class="col-lg-9">
          <CommonTable2
              :table="tableData"
              rowIdentifier="drugstoreId"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              :key="refreshTable"
              :showPaginationTop="false"
              :showPaginationBottom="false"

          />
        </div>


      </div>



    <b-modal
        v-model="showDetailsModal"
        id="details-modal-control-files"
        scrollable
        title="Szczegóły kontroli plików"
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        hide-footer


    >
      <div v-if="showDetailsModal">
        <ReportsControlFilesDetailsStage :drugstoreId="selectedDrugstoreId" />
      </div>


    </b-modal>





  </div>




</template>
<script>


import {log} from "@/state/pinia/log";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import {BModal} from "bootstrap-vue-next";
import ReportsControlFilesDetailsStage from "./ReportsControlFilesDetailsStage.vue";
import {useReportsManagerModule} from "@/state/pinia/reportsManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "ReportsControlFilesListStage",
  props: {},
  components: {
    ReportsControlFilesDetailsStage,
    BModal,
    CommonTable2

  },
  data() {
    return {
      selectedDrugstoreId:null,
      refreshTable:false,
      tableData: {
        headers: [],
        data: [],
        massActions: [],
      },
      timeBackwardsRequest:{
        minutesBackwards:0,
        hoursBackwards:0,
        daysBackwards:0,
      },
      availableHeaders: [
        {
          text: "Lp.",
          key: "listIndex",
          type: "number",
          sortable: true,
          class:"col-number"
        },
        {
          text: "ID apteki",
          key: "drugstoreId",
          type: "text",
          sortable: true,
          class:"col-number"
        },
        {
          text: "Nazwa apteki",
          key: "drugstoreName",
          type: "text",
          sortable: true,

        },
        {
          text: "Ilość wysłanych plików",
          key: "filesCount",
          type: "number",
          sortable: true,

        },
        {
          text: "Akcje",
          key: "actions",
          type: "actions",
          actions:[

            {
              text: "",
              icon: "fas fa-file-invoice",
              action: "view-files-control-details",
              enabled: true,
              tooltip: "Zobacz szczegóły",
              class:"btn btn-info table-actions-button edit-button"
            },


          ]
        }

      ],
      showDetailsModal:false,

    };
  },
  computed: {
    reportsModule(){
      return useReportsManagerModule();
    },

    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {


    refreshControlFilesList() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych kontrolnych...");

      var payload = {
        daysBackwards: this.timeBackwardsRequest.daysBackwards,
        hoursBackwards: this.timeBackwardsRequest.hoursBackwards,
        minutesBackwards: this.timeBackwardsRequest.minutesBackwards,
      }

      this.refreshTable = false;
      this.reportsModule.httpGetAllReportsFilesCountForDrugstores(payload).then((response) => {
        log.log(response)
        var controlRows = [];
        var fetchedRows = JSON.parse(JSON.stringify(response.data.payload));
        for (var i = 0; i < fetchedRows.length; i++) {
          fetchedRows[i]['listIndex'] = i + 1;

          controlRows.push(fetchedRows[i]);
        }


        this.tableData['headers'] = this.availableHeaders;

        this.tableData['massActions'] = [];

        this.tableData['data'] = controlRows;
        this.refreshTable = true;
        this.lazyloaderModule.setDisplayLazyLoader(false);

      });
    },
    runAction(event) {
      log.log(event);

      if(event.action.action === "view-files-control-details"){
        this.selectedDrugstoreId = event.itemData.drugstoreId;
        this.showDetailsModal = true;
      }

    },
    runMassAction(event) {
      log.log(event);
    },
    sort(sort) {
      log.log(sort);
    },
    checkAction(items) {
      log.log(items);
    },


  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    });
    this.refreshControlFilesList();
  },
  watch: {
    timeBackwardsRequest: {
      handler() {
        this.refreshControlFilesList();
      },
      deep: true,
    },


  },
};
</script>

<style scoped>


</style>
